import { memo } from 'react'

import { AVATAR_HEIGHT_16 } from '../../Avatar'
import {
  SelectDropdownEntityListItemContent,
  SelectDropdownListItem,
} from '../../Select'
import { useEmailListItemTypeIcon } from '../Email.hooks'

import { isPublicOption } from './EmailAccountSelectDropdownListItem.utils'

import * as styles from './EmailAccountSelectDropdownListItem.module.css'

function EmailAccountSelectDropdownListItem({ ref, value, ...restProps }) {
  const { Icon, tooltip } = useEmailListItemTypeIcon({
    isPublicOption,
    value,
  })

  return (
    <SelectDropdownListItem
      Content={SelectDropdownEntityListItemContent}
      contentProps={{
        ...restProps?.contentProps,
        avatarProps: {
          ...restProps?.contentProps?.avatarProps,
          avatarClassName: styles.icon,
          iconSize: AVATAR_HEIGHT_16,
          iconTooltip: tooltip,
          size: AVATAR_HEIGHT_16,
        },
      }}
      ref={ref}
      value={{ ...value, Icon }}
    />
  )
}

export default memo(EmailAccountSelectDropdownListItem)
